module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-1500.b5533eaa.svg";